import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class PaymentTermService extends Service {
	constructor(injector: Injector) {
		super("PaymentTerm", injector);
	}
	
	// API
	getDueDate(id: number, invoiceDate: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetDueDate/${id}/${invoiceDate.toDateString()}`);
	}
}